module.exports = __webpack_public_path__ + "static/media/mind-icon.3701e4a5.png";